<template>
    <div>
        <div v-show="loading">
            <h4 class="mb-4 mt-4">{{ $t("message_loading") }}</h4>
        </div>
        <div class="pl-3 pr-3 row" v-if="!loading">
            <!-- Only show on the search page and if the filters/results are ready -->
            <div class="col-12 mb-4 pt-1" id="search_box_blue" v-if="routeName == 'search'">
                <div class="row" id="not-safari">
                    <div class="col-lg-3 col-12">
                        <h3 class="h5 mt-4">{{ $t("search_box") }}</h3>
                    </div>
                    <div class="col-lg-9 col-12" id="search_field">
                        <form v-on:submit.prevent>
                            <fieldset id="search_fieldset">
                                <div class="row">
                                    <div class="input-group mb-3 col-8 mt-4">
                                      <label for="search_box" class="d-none">Search: </label>
                                      <input type="text" name="search_box" id="search_box" class="ontario-input mb-0 border-right-0" v-model="keywords">
                                      <div class="input-group-append" id="search_append">
                                          <button class="ontario-button--primary"  id="search_submit" @click="submitForm()">{{ $t("search_button") }}</button>
                                      </div>
                                    </div>
                                
                                    <div class="col-2">
                                        <button class="ontario-button ontario-button--tertiary mt-4 pr-0"  id="search_clear" @click="clearKeywords()">{{ $t("search_clear") }}</button>
                                    </div>
                                </div>
                                <!-- <input class="ontario-input mb-0" id="search_input" type="text" v-model="keywords">
                                <button type="submit" id="search_submit" class="ml-n2 ontario-button ontario-button--primary" @click="submitForm()">{{ $t("search_button") }}</button>
                                <button class="ontario-button ontario-button--tertiary mt-0 pr-0"  id="search_clear" @click="clearKeywords()">Clear</button> -->
                            </fieldset>
                        </form>
                    </div>
                </div>
                <div id="is-safari">
                    <div class="col-lg-4 col-12">
                        <h3 class="h5 mt-4">{{ $t("search_box") }}</h3>
                    </div>
                    <div class="col-lg-8 col-12 pl-0 ml-n2" id="search_field">
                        <form v-on:submit.prevent>
                            <fieldset id="search_fieldset">
                                <label for="search_input" class="d-none">Search: </label>
                                <input class="ontario-input mb-0" id="search_input" name="search_input" type="text" v-model="keywords">
                                <button type="submit" id="search_submit" class="ml-n2 ontario-button ontario-button--primary" @click="submitForm()">{{ $t("search_button") }}</button>
                                <button class="ontario-button ontario-button--tertiary mt-0 pr-0"  id="search_clear" @click="clearKeywords()">{{ $t("search_clear") }}</button>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>

            <div v-if="routeName == 'home'" class="col-12">
                <features></features>
            </div>

            <div class="col-lg-4 pl-0 pl-lg-3 filter_area">
                <filters :apiEndPoints=apiEndPoints :routeName=routeName ref="filters" v-on:change-filters="updateResults"></filters>
            </div>

            <div class="col-md-12 col-lg-8 pl-0 pr-0 mt-3">

                <section v-if="errored">
                    <p>{{ $t("message_error") }}</p>
                </section>

                <section v-else>

                    <div id="filter_result_box" v-if="selected.length > 0" class="mb-5 border">
                    <div id="filter_result_list" class="pb-0">
                        <p>{{ total }} {{ $t("filter_results") }}</p>
                        <p class="filter_result mr-1 float-left hand mr-3" v-for="(item, index) in selected" v-bind:key="index" v-on:click="removeSelected(item, index)">
                        <strong>X</strong> {{ item.label }}
                        </p>
                        <div class="clearfix"></div>
                    </div>
                    </div>

                    <div id="news_feed" role="feed">

                        <div class="clearfix"></div>
                        <p v-if="noResults"><strong>No Results</strong></p>
                        <!-- releases -->
                        <div class="mb-4" v-for="(news, index) in results" v-bind:key="news.id" role="article" tabindex="0" :aria-posinset=(index+1) :aria-setsize=results.length>
                            <div class="row">
                                <div class="col-12">
                                    <p class="mb-3 heading_grey text-uppercase">
                                        <span v-if="news.previous_administration_flag" class="archived_label">{{ $t("message_archived") }}&nbsp; {{ news.release_type_name }} </span>
                                        <span v-else>{{ news.release_type_name }}</span>
                                    </p>
                                    <router-link class="a_no_line" :to="{ name: 'release', params: { lang: news.language, type: news.release_type_label, release_id: news.id, slug: news.slug } }"><h3 class="h5 mb-2" v-html="news.content_title"></h3></router-link>
                                    <div v-html="news.content_lead"></div>
                                    <p class="feature_date font-weight-bold mb-0">{{ news.release_date_time_formatted }}</p>
                                    <router-link :to="{ name: 'ministry', params: { acronym: news.ministry_acronym.toLowerCase() } }">
                                      {{ news.ministry_abbreviated }}
                                    </router-link>
                                </div>
                            </div>
                        <hr />
                        </div><!-- releases -->

                    </div>

                    <pagination v-if="hasPagination && results.length" v-on:update-page="nextPage" :page=page :lastPage=lastPage :limit=limit :fetchingResults=fetchingResults></pagination>

                </section>

            </div><!-- right -->
        </div>
    </div>
</template>

<script>
import Filters from '../components/Filters.vue'
import Pagination from '../components/Pagination.vue'
import Features from '../components/Features.vue'

export default {

  props: ['hasPagination', 'limit'],

  components: {
    Pagination,
    Filters,
    Features
  },

  data () {
    return {
      apiEndPoints: ['types', 'ministries', 'topics'],
      results: [],
      noResults: false,
      page: 1,
      lastPage: null,
      total: null,
      loading: false,
      fetchingResults: false,
      errored: false,
      ministryName: null,
      keywords: null,
      filterValues: {
        types: null,
        ministry_acronym: null,
        ministries: null,
        topics: null,
        start_date: null,
        end_date: null,
        sort: 'desc'
      },
      selected: []
    }
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  },
  methods: {
    // If query string data is present, set the keywords (if available)
    setDataFromQueryString () {
      let queryParams = this.$route.query
      if ( Object.keys(queryParams).length !== 0 ) {
        this.keywords = this.$route.query.keywords
      }
    },
    // fetch the results data from the appropriate endpoint (releases/search)
    fetchResultsData (wasPaginated) {
      this.fetchingResults = true

      let endPoint = 'releases'

      if (this.routeName == 'search') {
        endPoint = 'search'
        this.fireGAEvent() // Keyword GA events should only fire on search
      }

      // Get the ministry acronym from the $route and send it in the axios call (only applies to ministry news pages, otherwise can be null)
      this.filterValues.ministry_acronym = this.$route.params.acronym

      // if the route has meta.type defined, push that to the types array, and send it in the axios call
      let types = []
      if (this.$route.meta.type) {
        types.push(this.$route.meta.type)
      }
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + endPoint, {
          params: {
            language: this.$root.$i18n.locale, // use the root language locale variable
            keywords: this.keywords,
            types: (types.length ? types : this.filterValues.types), // if types has a value, send it, else send the filterValue
            ministry_acronym: this.filterValues.ministry_acronym,
            ministries: this.filterValues.ministries,
            topics: this.filterValues.topics,
            start_date: this.filterValues.start_date,
            end_date: this.filterValues.end_date,
            sort: this.filterValues.sort,
            limit: this.limit,
            page: this.page
          }
        })
        .then(response => {
          // If pagination was triggered, push the response data to the results array, otherwise reset the data with the response
          ( wasPaginated ? this.results.push(response.data.data) : this.results = response.data.data )
          // Flatten results array
          this.results = this.results.flat()

          // If there are no results, trigger no results message
          if (this.results.length < 1) {
            this.noResults = true
          } else {
            this.noResults = false
          }

          // Set page, lastPage, and total from meta information
          this.page     = response.data.meta.current_page
          this.lastPage = response.data.meta.last_page
          this.total    = response.data.meta.total

          // If this is a ministry specific news route, set the ministryName and activeMinistryAcronym from the results
          // and emit it to the parent component (News) for page title and rss routing
          if (this.routeName == 'ministry' && this.results.length > 0)
          {
            // Each result will have the ministry name, therefore we can just grab it from the first result
            // TODO: likely a better way to grab ministry_name and acronym now, should revist api as a whole post launch
            this.ministryName         = this.results[0].ministry_abbreviated
            let activeMinistryAcronym = this.results[0].ministry_acronym.toLowerCase()
            this.$emit('ministry-name', this.ministryName, activeMinistryAcronym)

            if (this.$route.name == 'ministry') {
              this.$root.$emit('setOppositeMinistryAcronym', this.results[0].ministry_acronym_opposite)
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.errored = true

        })
        .finally(() => (
          this.loading = false,
          this.fetchingResults = false
        ))
    },
    // This function is triggered when the change-filters event is fired from the child component (Filters)
    // It clears the results, sets the selected variable, resets the filterValues data (used in axios call), and fetches new data
    updateResults (selected_filters, selected_types, selected_ministries, selected_topics, selected_start_date, selected_end_date, selected_sort) {
      // Clear results
      this.results = []
      // Set selected
      this.selected = selected_filters

      this.filterValues.types      = selected_types
      this.filterValues.ministries = selected_ministries
      this.filterValues.topics     = selected_topics
      this.filterValues.start_date = selected_start_date
      this.filterValues.end_date   = selected_end_date
      this.filterValues.sort       = selected_sort
      // Reset page
      this.page = 1
      // Get releases - set fetch data to reset array
      this.fetchResultsData(false)
    },
    // Pagination code - update value of page variable, then fetch more results
    nextPage (nextPage) {
      this.page = nextPage
      this.fetchResultsData(true)
    },
    // Remove the value from the appropriate filters data variable
    removeSelected (item, index) {
      this.page = 1
      this.$refs.filters.removeSelected(item, index)
    },
    // Clear the keywords and the filters
    clearKeywords () {
      this.keywords = ''
      this.$refs.filters.clearFilters()
    },
    submitForm () {
      this.$refs.filters.updateFilters()
    },
    // Trigger a GA search event with the keyword value
    fireGAEvent () {
      window.dataLayer.push({
        'event': 'search',
        'searchTerm': (this.keywords ? this.keywords : undefined) // undefined is needed instead of null for GA
      })
    }
  }, // end of methods
  mounted () {
    this.setDataFromQueryString()
  }
}
</script>
